import axios from "axios";
import API_BASE_URL from "config/api";

// api/sales.js

export const fetchProductSalesSummary = async (productId, interval) => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    console.warn("❌ No access token.");
    return { interval, actual_sales: [], predicted_sales: [], forecast_summary: null, forecast_metrics: null, };
  }

  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/products/${productId}/sales-summary/?interval=${interval}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    return {
      interval,
      actual_sales: res.data.actual_sales || [],
      predicted_sales: res.data.predicted_sales || [],
      forecast_generated_at: res.data.forecast_generated_at || null,
      forecast_summary: res.data.forecast_summary || null,
      forecast_metrics: res.data.forecast_metrics || null,
    };
  } catch (err) {
    console.error("❌ Failed to fetch sales-summary:", err);
    return { interval, actual_sales: [], predicted_sales: [],forecast_generated_at: null,  forecast_summary: null, forecast_metrics: null,  };
  }
};

export const fetchShopSalesSummary = async (interval) => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    console.warn("❌ No access token.");
    return {
      interval,
      actual_sales: [],
      predicted_sales: [],
      forecast_generated_at: null,
      forecast_summary: null,
      forecast_metrics: null,
    };
  }

  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/dashboard/forecast/?interval=${interval}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    return {
      interval,
      actual_sales: res.data.actual_sales || [],
      predicted_sales: res.data.predicted_sales || [],
      forecast_generated_at: res.data.forecast_generated_at || null,
      forecast_summary: res.data.forecast_summary || null,
      forecast_metrics: res.data.forecast_metrics || null,
    };
  } catch (err) {
    console.error("❌ Failed to fetch shop sales-summary:", err);
    return {
      interval,
      actual_sales: [],
      predicted_sales: [],
      forecast_generated_at: null,
      forecast_summary: null,
      forecast_metrics: null,
    };
  }
};